import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Actions} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {SettingsService} from 'src/app/services/settings.service';
import {StorageService} from 'src/app/services/storage.service';
import {phoneNumbervalidator} from 'src/app/shared/validators/input-validators';
import {InstutionUser} from 'src/app/store/entities/instution-settings/instution-user/instution-user.model';
import {AppState} from 'src/app/store/reducers';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-verify-phone-number',
  templateUrl: './verify-phone-number.component.html',
  styleUrls: ['./verify-phone-number.component.scss']
})
export class VerifyPhoneNumberComponent implements OnInit {

  title: string;
  citizenuserForm: FormGroup;
  instutionUser: InstutionUser;

  constructor(
    private store: Store<AppState>,
    @Inject(MAT_DIALOG_DATA) data,
    private dialogRef: MatDialogRef<VerifyPhoneNumberComponent>,
    private fb: FormBuilder,
    private actions$: Actions,
    private settingsService: SettingsService,
    private storageService: StorageService
  ) {}



  ngOnInit(): void {

    this.citizenuserForm = this.fb.group({
      userPhoneNumber: [null,[Validators.required, Validators.pattern(phoneNumbervalidator)],],
      //
    });
  }

  submitForm(formData?: InstutionUser) {
    formData = {
      ...formData,
    };
    console.log('formData', formData);

    if (this.instutionUser?.profile?.profileUniqueId) {
      // this.store.dispatch(
      //   updateInstitutionUsers({
      //     input: {
      //       ...formData,
      //       profileUniqueId: this.instutionUser?.profile?.profileUniqueId,
      //     },
      //   })
      // );
    } else {
      // this.store.dispatch(createInstitutionUsers({input: { ...formData } }));
    }
    this.closeModal(true);
  }

  closeModal(close: boolean): void {
    if (close) {
      this.dialogRef.close();
    }
  }
}
